<template>
  <div class="about">
    <img class="top-bg" src="../assets/about/bg1.png" alt="" style="">
    <div class="lab">
      <div class="lab-top">
        <img src="../assets/about/img.png" alt="">
        <div class="lab-top-des-box">
          <div class="lab-top-title">
            {{$t('home_lab_title')}}
          </div>
          <div class="lab-top-des">
            {{$t('about_lab_des')}}
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="viewpoint">
      <div class="section-title">{{ $t('about_viewpoints') }}</div>
      <video width="80%" controls class="video-class">
          <source src="/about-video.mp4" type="video/mp4">
      </video>
    </div> -->
    <!-- <div class="research-directions">
      <div class="section-title">{{ $t('home_directions') }}</div>
      <div class="direction-item" v-for="(direction, index) in researchDirections" :key="index" :class="{'reverse': index === 1 || index === 3}">
        <div class="direction-item-left">
          <div>
            <div class="direction-title">{{ direction.title }}</div>
            <div class="direction-details">
              <span v-for="(detail, detailIndex) in direction.details" :key="detailIndex">
                <span class="dot">·</span>{{ detail }}<br>
              </span>
            </div>
          </div>
        </div>
        <div class="direction-item-img">
          <img :src="direction.image" :alt="direction.title">
        </div>
      </div>
    </div> -->
    <div class="current-leadership">
      <div class="section-title">{{ $t('current_leadership') }}</div>
      <div class="leader-item-container">
        <div class="leader-item" v-for="(leader, index) in leaders" :key="index">
          <img :src="leader.image" :alt="leader.name">
          <div>
            <div class="leader-name">{{ leader.name }}</div>
            <p>{{ leader.position }}</p>
            <div class="moreBtn" @click="showPopup(index)">{{ $t('find_more') }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="honor-container">
      <div class="honor">
        <div class="section-title">{{ $t('core_achievements') }}</div>
        <div class="honer-cont" style="margin-bottom:50px">
          <img src="../assets/about/core.png" alt="">
          <div class="">
            <div class="honor-title">{{ $t('core_title') }}</div>
            <div v-for="item in 2" :key="item" class="honor-des">{{ $t(`core_p${item}`) }}</div>
          </div>
        </div>
        <div class="honer-cont">
          <img src="../assets/about/honer.png" alt="">
          <div class="">
            <div class="honor-title">{{ $t('honor_title') }}</div>
            <div v-for="item in 4" :key="item" class="honor-des">{{ $t(`honor_p${item}`) }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="honor-container">
      <div class="honor">
        <div class="section-title">{{ $t('honor') }}</div>
        <div class="honer-cont">
          <img src="../assets/about/honer.png" alt="">
          <div class="">
            <div class="honor-title">{{ $t('honor_title') }}</div>
            <div v-for="item in 4" :key="item" class="honor-des">{{ $t(`honor_p${item}`) }}</div>
          </div>
        </div>
      </div>
    </div> -->
    <div v-if="isPopupVisible" class="popup-container">
      <div class="popup-content">
        <div class="closeBtn" @click="hidePopup">
          <img src="../assets/close.png" alt="">
        </div>
        <div class="pop-line"></div>
        <div class="pop-name">{{leaders[curIndex].name}}</div>
        <div class="pop-position">{{leaders[curIndex].position}}</div>
        <div class="pop-des">{{leaders[curIndex].des}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import yjfxImg1 from '../assets/home/yjfx-img1.png'
import yjfxImg2 from '../assets/home/yjfx-img2.png'
import yjfxImg3 from '../assets/home/yjfx-img3.png'
import yjfxImg4 from '../assets/home/yjfx-img4.png'
import leader1 from '../assets/home/leader1.png'
import leader2 from '../assets/home/leader2.png'
export default {
  name: 'About',
  data() {
    return {
      researchDirections: [
        {
          title: this.$t('home_directions1.title'),
          details: [
            this.$t('home_directions1.details1'),
            this.$t('home_directions1.details2'),
            this.$t('home_directions1.details3'),
            this.$t('home_directions1.details4'),
          ],
          image: yjfxImg1
        },
        {
          title: this.$t('home_directions2.title'),
          details: [
            this.$t('home_directions2.details1'),
            this.$t('home_directions2.details2'),
            this.$t('home_directions2.details3'),
            this.$t('home_directions2.details4'),
          ],
          image: yjfxImg2
        },
        {
          title: this.$t('home_directions3.title'),
          details: [
            this.$t('home_directions3.details1'),
            this.$t('home_directions3.details2'),
            this.$t('home_directions3.details3'),
            this.$t('home_directions3.details4'),
          ],
          image: yjfxImg3
        },
        {
          title: this.$t('home_directions4.title'),
          details: [
            this.$t('home_directions4.details1'),
            this.$t('home_directions4.details2'),
            this.$t('home_directions4.details3'),
            this.$t('home_directions4.details4'),
          ],
          image: yjfxImg4
        }
      ],
      leaders: [
        {
          name: this.$t('leader1.name'),
          image: leader1,
          position: this.$t('leader1.position'),
          des:this.$t('leader1.des')
        },
        {
          name: this.$t('leader2.name'),
          image:leader2,
          position: this.$t('leader2.position'),
          des:this.$t('leader2.des')
        }
      ],
      newsList: [
        {
          title: '北京大学 - 时空道宇先进通信联合实验室签约仪式',
          date: '2023.09.15',
          description: '北京大学 - 时空道宇先进通信联合实验室正式成立',
          image: 'https://via.placeholder.com/300x200?text=签约仪式'
        },
        {
          title: '第一届新一代空天通信技术及产业发展研讨会',
          date: '2024.04.14',
          description: '会议聚焦空天通信技术前沿，探讨产业发展趋势。',
          image: 'https://via.placeholder.com/300x200?text=研讨会'
        }
      ],
      showInfo: {},
      isPopupVisible:false,
      curIndex: 0
    };
  },
  methods: {
    showPopup(index) {
      this.curIndex = index
      this.isPopupVisible = true;
    },
    hidePopup() {
      this.isPopupVisible = false
    }
  }
}
</script>
<style scoped lang="scss">
.about {
  color: #FEFEFE;
  position: relative;
  white-space: pre-line;
  > div {
    position: relative;
  }
  .top-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }
}
.lab {
  padding-bottom: 100px;
  .lab-top {
    padding-top: 150px;
    display: flex;
    align-items: center;
    img {
      margin-right: 4vw;
      width: 39%;

    }
    
    .lab-top-des-box {
      flex: 1;
      .lab-top-title {
        font-weight: 300;
        font-size: 44px;
        line-height: 44px;
        margin-bottom: 35px;
      }
      font-weight: 400;
      font-size: 16px;
      color: #fff;
      line-height: 30px;
      text-align: left;
      .lab-top-des {
        text-indent: 2em;
      }
    }
  }
}
.section-title {
  font-weight: 500;
  font-size: 60px;
  color: #FFFFFF;
  padding: 100px 0;
  text-align: center;
}
.research-directions {
  color: #FFFFFF;
  .direction-item-left {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .direction-item {
    display: flex;
    margin-bottom: 60px;
    > div {
      width: 50%;
      img {
        width: 90%;
      }
    }
    &.reverse {
      flex-direction: row-reverse;
      .direction-item-left {
        align-items: center;
      }
      .direction-item-img {
        text-align: left;
      }
    }
    .direction-item-img {
      text-align: right;
    }
  }
  .direction-details {
    font-weight: 400;
    font-size: 16px;
    color: #FFFFFF;
    line-height: 36px;
    span.dot {
      font-weight: 700;
      margin-right: 10px;
    }
  }
  .direction-title {
    font-weight: 400;
    font-size: 50px;
    margin-bottom: 35px;
  }
}
.current-leadership {
  background: #FFFFFF;
  margin: 0 -9vw;
  color: #333333;
  padding-bottom: 160px;
  .section-title {
    color: #333333;
  }
  .leader-item-container {
    padding: 0 9vw;
    display: flex;
  }
  .leader-item {
    width: 50%;
    display: flex;
    img {
      width: 200px;
      margin-right: 32px;
    }
    > div{
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin: 3% 0;
      .leader-name {
        font-size: 30px;
        color: #333333;
        line-height: 1;
        font-weight: 500;
      }
      p{
        font-weight: 400;
        font-size: 16px;
        line-height: 1;
      }
      .moreBtn {
        width: 114px;
        height: 36px;
        background: #063793;
        border-radius: 18px;
        color: #FFFFFF;
        line-height: 36px;
        text-align: center;
        cursor: pointer;
      }
    }
  }
}
.honor-container {
  background: rgb(5, 43, 115);
  // background: url("../assets/about/bg.png");
  // background-size: contain;
  // background-position: center top; /* 图片居中显示 */
  margin: 0 -9vw;
  padding: 0 9vw;
}
.honer-bg {
  background: url("../assets/about/bg.png");
  background-size: contain;
  background-position: center top; /* 图片居中显示 */
}
.honor {
  padding-bottom: 60px;
  .honer-cont {
    padding-left: 3vw;
    display: flex;
    align-items: center;
    img {
      width: 25%;
    }
    > div {
      width: calc(75% - 4vw);
      padding-left: 4vw;
      display: flex;
      flex-direction: column;
      justify-content: center;
      
    }
    .honor-title {
      font-weight: bold;
      font-size: 30px;
      color: #FFFFFF;
      margin-bottom: 6vh;
    }
    .honor-des {
      font-weight: 400;
      font-size: 16px;
      color: #FFFFFF;
      line-height: 36px;
      text-indent: 2em;
    }
  }
}
.popup-container {
  position: fixed !important;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* 半透明黑色背景 */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999;
  .popup-content {
    width: 798px;
    background: #000000;
    border-radius: 20px;
    padding: 0 40px 0 80px;
    box-sizing: border-box;
    line-height: 1;
    .closeBtn {
      height: 95px;
      text-align: right;
      cursor: pointer;
      img {
        width: 28px;
        margin-top: 33px;
      }
    }
    .pop-line {
      width: 42px;
      height: 12px;
      background: #FFFFFF;
      border-radius: 6px;
    }
    .pop-name {
      font-weight: 500;
      font-size: 30px;
      margin-top: 26px;
    }
    .pop-position {
      margin-top: 26px;
      font-weight: 400;
      font-size: 16px;
    }
    .pop-des {
      margin-top: 50px;
      font-weight: 400;
      font-size: 16px;
      padding-bottom: 50px;
      line-height: 30px;
    }
  }
}
.viewpoint {
    padding-bottom: 70px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    .video-class {
      margin: auto;
    }
  }
</style>
